import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Login.css";

const Login = ({ onLogin }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post("https://backend-vbfh.onrender.com/api/auth/login", {
                email,
                password,
            });

            if (response.data.success) {
                localStorage.setItem("isAuthenticated", "true");
                localStorage.setItem("userRole", response.data.user.rol);
                localStorage.setItem("username", response.data.user.nombre);

                onLogin(response.data.user); // Actualiza el estado global

                // Redirigir según el rol
                if (response.data.user.rol === "admin") {
                    navigate("/admin");
                } else if (response.data.user.rol === "trabajador") {
                    navigate("/Trabajador");
                } else {
                    navigate("/Login");
                }
            } else {
                alert("Usuario o contraseña incorrectos");
            }
        } catch (error) {
            alert("Error al conectar con el servidor");
        }
    };

    return (
        <div className="login-container">
            <div className="wrapper">
                <h1>Iniciar Sesión</h1>
                <form onSubmit={handleLogin}>
                    <div className="input-box">
                        <input
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="input-box">
                        <input
                            type="password"
                            placeholder="Contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit">Ingresar</button>
                </form>
            </div>
        </div>
    );
};

export default Login;